const StatusModel = {};

// Available admin color classes "order-detail__select--..."
// resources/assets/js/pages/admin/orderDetail/tabs/MainOrderDetail.vue
const StatusColor = {
  GRAY: 'gray',
  RED: 'red',
  ORANGE: 'orange',
  GREEN: 'green',
};

StatusModel.WAITING_FOR_PAYMENT = {
  id: 1,
  title: 'Waiting for payment',
  adminColor: StatusColor.GRAY,
};

StatusModel.PAID = {
  id: 2,
  title: 'Paid',
  adminColor: StatusColor.GREEN,
};

StatusModel.IN_PROGRESS = {
  id: 3,
  title: 'In progress',
  icon: '/images/icons/progress.svg',
  adminColor: StatusColor.GREEN,
};

StatusModel.DONE = {
  id: 4,
  title: 'Done',
  icon: '/images/icons/finish.svg',
  final: true,
  adminColor: StatusColor.GRAY,
};

StatusModel.CANCELED = {
  id: 5,
  title: 'Canceled',
  icon: '/images/icons/canceled.svg',
  adminColor: StatusColor.RED,
};

StatusModel.PARTIAL_REFUND = {
  id: 6,
  title: 'Partial Refund',
  icon: '/images/icons/refund.svg',
  final: true,
  adminColor: StatusColor.RED,
};

StatusModel.FULL_REFUND = {
  id: 7,
  title: 'Refund',
  icon: '/images/icons/refund.svg',
  final: true,
  adminColor: StatusColor.RED,
};

StatusModel.NOT_PAID = {
  id: 8,
  title: 'Not paid',
  adminColor: StatusColor.RED,
};

StatusModel.CHECK = {
  id: 9,
  title: 'Check',
  icon: '/images/icons/binocular.svg',
  adminColor: StatusColor.ORANGE,
};

StatusModel.PROBLEM = {
  id: 10,
  title: 'Problem',
  icon: '/images/icons/alert.svg',
  adminColor: StatusColor.RED,
};

StatusModel.ON_AUCTION = {
  id: 11,
  title: 'On the auction',
  adminColor: StatusColor.GREEN,
};

StatusModel.IN_WARRANTY = {
  id: 12,
  title: 'Warranty',
  icon: '/images/icons/clock.svg',
  adminColor: StatusColor.GRAY,
};

StatusModel.MANUAL_DISTRIBUTION = {
  id: 13,
  title: 'Manual distribution',
  icon: '/images/icons/clock.svg',
  adminColor: StatusColor.ORANGE,
};

/**
 * @deprecated решили отказаться от функцонала в рамках эпика заявок
 */
StatusModel.WAITING_FOR_EXECUTOR = {
  id: 14,
  title: 'Assign to PRO',
  icon: '/images/icons/clock.svg',
  adminColor: StatusColor.RED,
};

StatusModel.LOST_CLIENT = {
  id: 15,
  title: 'Lost client',
  icon: '/images/icons/clock.svg',
  final: true,
  isSettable: true,
  adminColor: StatusColor.RED,
};

StatusModel.WAITING_FOR_EXECUTOR_SELECTION = {
  id: 16,
  title: 'Waiting for executor selection',
  icon: '/images/icons/clock.svg',
};

StatusModel.AUCTION_OVERDUE = {
  id: 17,
  title: 'Auction overdue',
};

StatusModel.VERIFICATION = {
  id: 18,
  title: 'Manager verification',
};

StatusModel.LIST = [
  StatusModel.WAITING_FOR_PAYMENT,
  StatusModel.PAID,
  StatusModel.ON_AUCTION,
  StatusModel.MANUAL_DISTRIBUTION,
  StatusModel.IN_PROGRESS,
  StatusModel.CHECK,
  StatusModel.IN_WARRANTY,
  StatusModel.PROBLEM,
  StatusModel.DONE,
  StatusModel.CANCELED,
  StatusModel.PARTIAL_REFUND,
  StatusModel.FULL_REFUND,
  StatusModel.NOT_PAID,
  StatusModel.LOST_CLIENT,
  StatusModel.WAITING_FOR_EXECUTOR_SELECTION,
  StatusModel.AUCTION_OVERDUE,
  StatusModel.VERIFICATION,
];

StatusModel.ID_TO_DATA = {
  [StatusModel.WAITING_FOR_PAYMENT.id]: StatusModel.WAITING_FOR_PAYMENT,
  [StatusModel.PAID.id]: StatusModel.PAID,
  [StatusModel.IN_PROGRESS.id]: StatusModel.IN_PROGRESS,
  [StatusModel.DONE.id]: StatusModel.DONE,
  [StatusModel.CANCELED.id]: StatusModel.CANCELED,
  [StatusModel.PARTIAL_REFUND.id]: StatusModel.PARTIAL_REFUND,
  [StatusModel.FULL_REFUND.id]: StatusModel.FULL_REFUND,
  [StatusModel.NOT_PAID.id]: StatusModel.NOT_PAID,
  [StatusModel.CHECK.id]: StatusModel.CHECK,
  [StatusModel.PROBLEM.id]: StatusModel.PROBLEM,
  [StatusModel.ON_AUCTION.id]: StatusModel.ON_AUCTION,
  [StatusModel.IN_WARRANTY.id]: StatusModel.IN_WARRANTY,
  [StatusModel.MANUAL_DISTRIBUTION.id]: StatusModel.MANUAL_DISTRIBUTION,
  [StatusModel.LOST_CLIENT.id]: StatusModel.LOST_CLIENT,
  [StatusModel.WAITING_FOR_EXECUTOR_SELECTION.id]: StatusModel.WAITING_FOR_EXECUTOR_SELECTION,
  [StatusModel.AUCTION_OVERDUE.id]: StatusModel.AUCTION_OVERDUE,
  [StatusModel.VERIFICATION.id]: StatusModel.VERIFICATION,
};

StatusModel.CAN_STUCK_STATUSES = [
  StatusModel.PAID,
  StatusModel.CHECK,
  StatusModel.PROBLEM,
  StatusModel.ON_AUCTION,
  StatusModel.IN_WARRANTY,
  StatusModel.MANUAL_DISTRIBUTION,
];

StatusModel.ACTIVE_STATUSES_ID = [
  StatusModel.IN_PROGRESS.id,
  StatusModel.PAID.id,
  StatusModel.CHECK.id,
  StatusModel.VERIFICATION.id,
  StatusModel.MANUAL_DISTRIBUTION.id,
  StatusModel.AUCTION_OVERDUE.id,
  StatusModel.ON_AUCTION.id,
  StatusModel.PROBLEM.id,
  StatusModel.WAITING_FOR_EXECUTOR_SELECTION.id,
];

StatusModel.FINISHED_STATUSES_ID = [
  StatusModel.IN_WARRANTY.id,
  StatusModel.DONE.id,
  StatusModel.CANCELED.id,
  StatusModel.PARTIAL_REFUND.id,
  StatusModel.FULL_REFUND.id,
  StatusModel.LOST_CLIENT.id,
];

StatusModel.POSITIVE_FINISHED_STATUSES = [
  StatusModel.DONE.id,
  StatusModel.IN_WARRANTY.id,
  StatusModel.CHECK.id,
];

StatusModel.POSITIVE_FLOW = [
  StatusModel.IN_PROGRESS.id, ...StatusModel.POSITIVE_FINISHED_STATUSES,
];

StatusModel.DISABLED_STATUSES_ID = [
  StatusModel.CANCELED.id,
  StatusModel.FULL_REFUND.id,
];

StatusModel.ORDER_EXTERNAL_FLAGS = {
  // eslint-disable-next-line no-bitwise
  FLAG_NEED_ESTIMATION_TIME: 1 << 0,
  // eslint-enable-next-line no-bitwise
};

export default StatusModel;
